import { AppSettings } from "appSettings/appSettings.dev";
import { PublicClientApplication } from "@azure/msal-browser";
import memoize from "lodash/memoize";

export const pca = new PublicClientApplication({
  auth: {
    clientId: AppSettings.msal.clientId,
    redirectUri: AppSettings.msal.redirectUri,
    authority: AppSettings.msal.authority,
    postLogoutRedirectUri: "/",
  },
  cache: {
    cacheLocation: "localStorage",
  },
});

const getCurrentUser = (): string => {
  const { username } = pca.getAllAccounts()[0] || "";
  return username;
};

export default memoize(getCurrentUser);
